import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../../Context/AuthProvider';

const AccountInfos = () => {
  const { user, setIsLoggin } = useContext(AuthContext);

  // Ensure user is loaded before accessing properties
  const [name, setName] = useState('');
  const [vat, setVat] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [postcode, setPostcode] = useState('');

  const logout = () => {
    localStorage.removeItem('token');
    setIsLoggin(false);
  }

  useEffect(() => {
    if (user) {
      setName(user.name || '');
      setVat(user.vat_number || '');
      setEmail(user.email || '');
      setPhone(user.phone || '');
      setAddress(user.address || '');
      setPostcode(user.postcode || '');
    }
  }, [user]);

  return (
    <div className="account-infos">
      <h1>Fiók Név</h1>
      <form className='account-infos-form'>
        <input type="text" placeholder="Név" value={name} onChange={(e) => setName(e.target.value)} />
        <input type="text" placeholder='Adószám' value={vat} onChange={(e) => setVat(e.target.value)} />
        <input type="text" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input type="text" placeholder="Telefonszám" value={phone} onChange={(e) => setPhone(e.target.value)} />
        <input type="text" placeholder="Cím" value={address} onChange={(e) => setAddress(e.target.value)} />
        <input type="text" placeholder="Irányítószám" value={postcode} onChange={(e) => setPostcode(e.target.value)} />
      </form>
      <button>Mentés</button>
      <button onClick={logout}>Kijelentkezés</button>
    </div>
  );
};

export default AccountInfos;